/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.PointPromotionCampaign {
    "use strict";

    export class PointPromotionCampaignContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            private $translate: angular.translate.ITranslateService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.initializeContext();
            this.initializeSections();
        }

        initializeContext(): void {
            this.entityType = 'ClientPointPromotion';
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.pointPromotionCampaign;
            this.sectionTemplatePath = "app/plugins/pointPromotionCampaign/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN);
        }

        initializeSections(): void {
            this.sections.push(new MainSection(
                0,
                "SECTION_MAIN",
                "main.html",
                true,
                false,
                this.appSettings.API_ENDPOINTS.pointPromotionCampaign,
                "",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.PointPromotionCampaignMain,
                this.securityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            );

            this.sections.push(new PromotionsSection(
                0,
                "SECTION_CLIENT_POINT_PROMOTION_PROMOTIONS",
                "promotions.html",
                false,
                false,
                this.appSettings.API_ENDPOINTS.pointPromotionCampaign,
                "",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.PointPromotionCampaignPromotions,
                this.modalService,
                this.$translate,
                this.securityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            );

            this.copySecurityKey = Meevo.Components.Common.SecurityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
        }

        copySecurityKey: string;
        displayNameMaxLength: number = 32;

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        isDisabled(): boolean {
            return this.isReadonly || !this.isAccessible;
        }

        postCopy() {
            super.postCopy();
            let model = this.castModel<Model.IPointPromotionCampaign>();
            model.displayName += `_${ this.$translate.instant('LABEL_COPY').toLowerCase() }`;
            model.endDate = undefined;
            model.redeemByDate = undefined;
            model.objectState = Model.ObjectStateEnum.Active;
            model.pointPromotionCampaignId = undefined;
            model.id = undefined;

            if (model.displayName.length > this.displayNameMaxLength) {
                model.displayName = model.displayName.substring(0, this.displayNameMaxLength);
            }

            if (model.startDate < moment().startOf('day').toDate()) {
                model.startDate = undefined;
            }
            
            if (Model.Guard.isSomething(model.pointPromotions)) {
                model.pointPromotions.forEach(promo => {
                    promo.pointPromotionCampaign_TId = null;
                    promo.pointPromotion_TId = Guid.newSqlSequentialGuid().toString();
                });
            }
        }

        public edit(isUndeleting: boolean = false): void {
            if ((<any> this.selectedSection.model).hasRedeemByDatePassed) {
                this.modalService.alert(
                    'MESSAGE_CLIENT_POINT_PROMOTION_ENDED', 
                    Components.Modal.ModalTranslationModes.Translate, 
                    false
                );
                return;
            }

            super.edit(isUndeleting);
        }
    }
}